import React from 'react';
import { CircularProgress } from '@mui/material';
import DropdownSelect from '../../../components/DropdownSelect';
import { academicYears as AY_OPTIONS } from '../../../constants/academicYears';
import { ControlsRow, PaperWrapper, RightActionsRow } from '../styled';
import { AcademicYearFilterCardProps } from '../types/AcademicYearTypes';
import { StyledButton } from '../../Exams/styled';
import Icons from '../../../components/icons';

const AcademicYearFilterCard: React.FC<AcademicYearFilterCardProps> = ({
  academicYear,
  onChange,
  onSearch,
  isLoading
}) => {
  return (
    <PaperWrapper>
      <ControlsRow>
        <DropdownSelect
          label='Academic Year'
          placeholder='Select Academic Year'
          name='academicYear'
          value={academicYear}
          options={AY_OPTIONS}
          onChange={(e) => onChange(e.target.value as string)}
        />
      </ControlsRow>
      <RightActionsRow>
        <StyledButton onClick={onSearch} disabled={isLoading}>
          <Icons.SearchWhiteOutlined style={{ marginRight: '6px' }} />
          {isLoading ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            'Search'
          )}
        </StyledButton>
      </RightActionsRow>
    </PaperWrapper>
  );
};

export default AcademicYearFilterCard;
